import React from 'react'
import styled from 'styled-components'

const DivNoResultsSearch = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  margin-bottom: 15px;
`
const H4 = styled.h4`
    margin-bottom: 15px;
`
const P = styled.p`

`
const UL = styled.ul`

`
const LI = styled.li`

`
const ChatButton = styled.button`
    color: #007bff;
    cursor: pointer;
    border: none;
    background-color: transparent;
`


export default function NoResults() {
	function startLiveChat(){
        window.HubSpotConversations.widget.open();
    }

    return (                     
        <DivNoResultsSearch>
                <H4>We're sorry, no items were found for your search</H4>
                 <P>We suggest</P>
                 <UL>
                 <LI>Double-checking the spelling/accuracy of your search and trying again</LI>
                <LI>Contacting <a href="/pages/contact/contact-us">Customer Service</a> for assistance or <ChatButton onClick={startLiveChat} >starting a live chat</ChatButton></LI>
                 </UL>
        </DivNoResultsSearch>
    )
}